exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.field[data-v-272eff82] {\n    padding: 1rem;\n    background: #f5f5f5;\n    border: 1px solid #ccc;\n    border-radius: 0.25rem;\n}\n", ""]);

